const P = "PAPERWORK";

export const SET_USERS = `${P}/SET_USERS`;
